module.exports = "/_next/static/images/cc6b53b853f50a1a5ef59b182a466c0f-man-looking-up-smiling-md@3x.jpg.webp";